
export const SET_LOGIN_PENDING = 'SET_LOGIN_PENDING';
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';

export const checkLoginStatus = (dispatch) => {
    dispatch({ type: 'USER_FETCH_REQUESTED' });
}
